import type { ReactNode } from 'react';

interface HudRowProps {
  /** Mono-cased uppercase label that prefixes the row (e.g. "MODE"). */
  label: string;
  /** Primary controls — chips, hint text, scrubber. Renders on the left. */
  children: ReactNode;
  /**
   * Optional secondary content anchored to the right of the row —
   * "saved 3s ago", "5 runs", percentage readout, etc. Fixes the
   * old pattern of `margin-left: auto` orphaning a single trailing
   * element with awkward whitespace in between.
   */
  trailing?: ReactNode;
}

/**
 * One row inside the HUD shell. Two slots: a wrap-friendly main cluster
 * for controls and a fixed-width trailing cluster for status. The row
 * itself is capped at `--thud-row-max-width` and centred so wide
 * viewports don't stretch the chips across hundreds of pixels.
 */
export function HudRow({ label, children, trailing }: HudRowProps) {
  return (
    <div className="thud__row">
      <span className="thud__label">{label}</span>
      <div className="thud__row__main">{children}</div>
      {trailing && <div className="thud__row__trailing">{trailing}</div>}
    </div>
  );
}
